import React, { useEffect, useState } from "react";
import SharedDiv from "../../Components/SharedDiv/SharedDiv";
import ApplicatnInformation from "../../Pages/ApplicantInformationPage/ApplicantInformationModel";
import PersonalInformation from "../../Pages/ApplicantInformationPage/PersonalInformationModel";
import BeneficiaryInformation from "../../Pages/ApplicantInformationPage/BeneficiaryInformationModel";
import GeneralinformationModel from "../../Pages/ApplicantInformationPage/GeneralinformationModel";
import ProjectWorkPlanModule from "../../Pages/ProjectInformationPage/ProjectWorkPlanModule";
import UpdatestateApplicationInformationPage from "../../Services/ApplicantInformationPage/UpdateApplicantInformation";
import ButtonAHSF from "../../Components/ButtonAHSF";
import { useDispatch, useSelector } from "react-redux";
import { Await, json, useNavigate } from "react-router-dom";
import { GetValidatetateApplicationInformationPage } from "../../Redux/Reducers/ApplicationInformationValidationPage";
import { SetPersonalInformation } from "../../Redux/Reducers/PersonalInformation";
import $ from "jquery";
import PopupAHSF from "../../Components/PopupAHSF";
import { useParams } from "react-router-dom";

import loadConfig from "../../Services/apiService";
import { setRefreshTable } from "../../Redux/Reducers/VariousVariables";
import {
  GetActiveRound,
  GetApplicationInformatio,
} from "../../Redux/Reducers/ApplicationInformation";
import { decryptToken } from "../../Services/Account/EncryptionParams";
import Swal from "sweetalert2";
const ApplicantInformatonPage = () => {
  const dispatch = useDispatch(); // Hook to dispatch Redux actions
  const navigat = useNavigate(); // Hook to navigate between routes
  const AppGuid = useParams(); // Retrieves parameters from the URL
  const refreshTableStatus = useSelector((state) => state.refreshTableStatus); // Redux state for table refresh status
  const ApplicationInformationStatus = useSelector(
    (state) => state.ApplicationInformation.ApplicationStatus
  ); // Redux state for application status

  const state = useSelector((state) => {
    // Extracting various pieces of state from Redux store
    return {
      ApplicationInformation:
        state.ApplicationInformation.ApplicationInformation,
      ApplicationInformationloding: state.ApplicationInformation,
      BeneficiaryInformation:
        state.BeneficiaryInformation.BeneficiaryInformation,
      GeneralInformation: state.GeneralInformation.GeneralInformation,
      PersonalInformation: state.PersonalInformation.PersonalInformation,
      ApplicationInformationValidationPage:
        state.ApplicationInformationValidationPage
          .ApplicationInformationValidationPage,
      ActiveRound: state.ApplicationInformation.ActiveRound,
    };
  });

  // useEffect to handle side-effects (fetch data)
  useEffect(() => {
    if (AppGuid.AppGuid) {
      // Dispatch actions to fetch application information and active round
      dispatch(GetApplicationInformatio(decryptToken(AppGuid.AppGuid)));
      dispatch(GetActiveRound());
    }
  }, [
    refreshTableStatus.refreshApplicationInformation, // Triggers effect on table refresh
    AppGuid.AppGuid, // Triggers effect on AppGuid change
    ApplicationInformationStatus, // Triggers effect on status change
  ]);

  // Local state hooks for managing UI and data
  const [PersonalInformationUpdateData, setPersonalInformationUpdateData] =
    useState({ ...state.PersonalInformation }); // Cloning personal information state for updates

  const [GeneralInformationUpdateData, setGeneralInformationUpdateData] =
    useState({ ...state.GeneralInformation }); // Cloning general information state for updates

  const [dataJsonObject, SetDataJsonObject] = useState(); // Local state for JSON data
  const [isPopupOpenStatus, setisPopupOpenStatus] = useState(false); // Popup visibility state

  // Function to load configuration JSON
  const dataJson = async () => {
    let jsonData = await loadConfig(); // Asynchronous data loading
    SetDataJsonObject(jsonData); // Save JSON data to state
  };

  useEffect(() => {
    // Fetch JSON data on component mount
    dataJson();
  }, []);

  // Function to handle data saving
  const SaveDataPage = async (withValidate) => {
    const saved = await UpdatestateApplicationInformationPage(
      state.ApplicationInformation, // Pass application information
      state.PersonalInformation, // Pass personal information
      state.BeneficiaryInformation, // Pass beneficiary information
      state.GeneralInformation // Pass general information
    );

    if (withValidate == true && saved) {
      // If validation is required and data is saved
      const validate = await dispatch(
        GetValidatetateApplicationInformationPage(
          localStorage.getItem("aI_ApplicationInformationId") // Validate based on application ID
        )
      );

      if (validate.payload.length == 0) {
        // If validation passes, navigate to the next page
        $(".InformationProject").trigger("click");
      } else {
        setisPopupOpenStatus(true); // Show popup if validation fails
      }
    }
  };

  // Disable fields if certain conditions are met
  if (
    !(
      state.ActiveRound == state.ApplicationInformation?.aI_RoundYearId &&
      state.ApplicationInformation?.aI_ApplicationStatus?.canEdite &&
      window.location.href.includes("manager") == false
    )
  ) {
    $(".form-grid input").attr("disabled", true); // Disable input fields
    $(".form-grid select").attr("disabled", true); // Disable select fields
    $(".form-grid textarea").attr("disabled", true); // Disable textarea fields
    $(".form-grid input").css("background-color", "#F1F1F1"); // Change background for disabled fields
    $(".form-grid input").css("cursor", "not-allowed"); // Change cursor style for disabled fields
  }

  // Boolean to decide whether fields should be disabled
  const shouldDisableFields = !(
    state.ActiveRound == state.ApplicationInformation?.aI_RoundYearId && // Check active round
    state.ApplicationInformation?.aI_ApplicationStatus?.canEdite && // Check if editable
    window.location.href.includes("manager") == false // Check if not in "manager" view
  );

  return (
    <>
      <div>
        {/* Render sections of the page with shared components */}
        <SharedDiv
          showTitle={true}
          titleName="معلومات الطلب"
          child={[<ApplicatnInformation />]}
        />
        <SharedDiv
          showTitle={true}
          titleName="المعلومات الشخصية لمقدّم الطلب"
          child={[
            <PersonalInformation
              setPersonalInformationUpdateData={PersonalInformationUpdateData} // Pass update data to child component
            />,
          ]}
        />
        <SharedDiv
          showTitle={true}
          titleName="معلومات الجهة المستفيدة"
          child={[<BeneficiaryInformation />]}
        />
        <SharedDiv
          showTitle={true}
          titleName="معلومات عامة"
          child={[<GeneralinformationModel />]}
        />
      </div>

      {!shouldDisableFields ? (
        <div className="containerButtonMAin">
          {/* Render Save button */}
          <ButtonAHSF
            type={"submitter"}
            onClick={() => {
              SaveDataPage(false); // Save without validation
              Swal.fire({
                position: "center",
                icon: "success",
                title: "تم حفظ المعلومات بنجاح",
                showConfirmButton: false,
                timer: 1000,
              });
            }}
            disabled={false}
            title={"حفظ"}
            text={"حفظ"}
            show={true}
          />
          {/* Render Next button */}
          <ButtonAHSF
            type={"submitter"}
            onClick={() => {
              SaveDataPage(true); // Save with validation
            }}
            disabled={false}
            title={"التالي"}
            text={"التالي"}
            show={true}
          />
        </div>
      ) : (
        ""
      )}

      {/* Popup for validation errors */}
      <PopupAHSF
        isPopupOpenStatus={isPopupOpenStatus}
        isPopupOpenFunction={() => setisPopupOpenStatus(false)} // Close popup
        forValidate={true}
        maxWidth="50%"
        title="يرجى تعبئة الحقول المطلوبة"
        componentBody={state.ApplicationInformationValidationPage} // Validation messages
      />
    </>
  );
};

export default ApplicantInformatonPage;
